module.exports = __webpack_public_path__ + "img/Skill.57d572bf.svg";